import WarningIcon from '@mui/icons-material/Warning';
import ComputerIcon from '@mui/icons-material/Computer';
import * as React from 'react'

export default { WarningIcon, ComputerIcon, React }